// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9baed0f3","703":"28bc27d4","787":"a7e41ec8"}[chunkId] + ".chunk.js";
};